"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));

module.exports = function isPrimitive(value) {
  return value === null || typeof value !== 'function' && (0, _typeof2["default"])(value) !== 'object';
};